import React, { useState, useEffect } from "react";
import { Nav, Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FiGrid,
  FiUsers,
  FiBox,
  FiShoppingCart,
  FiCreditCard,
  FiFileText,
  FiDollarSign,
  FiClipboard,
  FiUser,
  FiHome,
  FiChevronLeft,
  FiChevronRight,
  FiMenu,
  FiLogOut,
} from "react-icons/fi";
import logo from "../assets/mboxLogo.jpeg";
import Cookies from "universal-cookie";

const Sidebar = ({
  collapsed,
  toggleSidebar,
  isMobile,
  showSidebarMobile,
  toggleSidebarMobile,
  handleLogout, // Asegúrate de pasar esta prop desde el componente padre
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("dashboard");
  const [hovered, setHovered] = useState(false);
  const cookies = new Cookies();

  // Detecta la ruta actual al cargar
  useEffect(() => {
    const path = location.pathname.split("/")[1] || "dashboard";
    setActiveKey(path);
  }, [location]);

  const handleSelect = (selectedKey) => {
    setActiveKey(selectedKey);
    navigate(`/${selectedKey}`);
    if (isMobile) {
      toggleSidebarMobile();
    }
  };

  const handleLogoutClick = () => {
    // Eliminar todas las cookies
    cookies.remove("nombre_Completo", { path: "/" });
    cookies.remove("correoElectronico", { path: "/" });
    cookies.remove("id_Usuario", { path: "/" });
    cookies.remove("token", { path: "/" });

    // Si hay un handleLogout prop, ejecutarlo
    if (handleLogout) {
      handleLogout();
    }

    // Redirigir al login
    navigate("/sistemaMBOX", { replace: true });

    // Cerrar sidebar en móvil si es necesario
    if (isMobile) {
      toggleSidebarMobile();
    }
  };

  const sidebarStyle = {
    height: "100vh",
    width: collapsed ? "80px" : "250px",
    backgroundColor: "#f8f9fa",
    color: "#333",
    position: isMobile ? "fixed" : "fixed",
    top: 0,
    left: showSidebarMobile || !isMobile ? 0 : "-250px",
    display: "flex",
    flexDirection: "column",
    paddingTop: "20px",
    transition: "all 0.3s",
    zIndex: 9999,
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
  };

  const navItems = [
    { key: "dashboard", icon: <FiGrid />, text: "Dashboard" },
    { key: "clientes", icon: <FiUsers />, text: "Clientes" },
    { key: "paquetes", icon: <FiBox />, text: "Paquetes" },
    { key: "ordenes", icon: <FiShoppingCart />, text: "Ordenes (PreFacturas)" },
    { key: "facturas", icon: <FiCreditCard />, text: "Facturación" },
    { key: "reempaques", icon: <FiCreditCard />, text: "Solicitud Reempaque" }, 
    { key: "informacion-sar", icon: <FiFileText />, text: "Información SAR" },
    { key: "empresas", icon: <FiHome />, text: "Empresas" },
    { key: "tasa-cambio", icon: <FiDollarSign />, text: "Tasa de Cambio" },
    { key: "reportes", icon: <FiClipboard />, text: "Reportes" },
    { key: "usuarios", icon: <FiUser />, text: "Usuarios" },
  ];

  return (
    <>
      {isMobile && !showSidebarMobile && (
        <button
          onClick={toggleSidebarMobile}
          style={{
            position: "fixed",
            top: 20,
            left: 20,
            backgroundColor: "#f0ad4e",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 10000,
          }}
        >
          <FiMenu size={22} />
        </button>
      )}

      <div
        style={sidebarStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={logo}
            alt='MBox Logo'
            style={{
              width: collapsed ? "50px" : "80px",
              height: "auto",
              transition: "width 0.3s",
            }}
          />
        </div>

        <Container fluid style={{ flexGrow: 1 }}>
          <Nav
            activeKey={activeKey}
            onSelect={handleSelect}
            className='flex-column'
            style={{ width: "100%" }}
          >
            {navItems.map((item) => (
              <Nav.Link
                key={item.key}
                eventKey={item.key}
                style={{
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: collapsed ? "center" : "flex-start",
                  padding: "10px 15px",
                  backgroundColor:
                    activeKey === item.key ? "#e9ecef" : "transparent",
                  borderLeft:
                    activeKey === item.key ? "3px solid #f0ad4e" : "none",
                }}
              >
                <span style={{ marginRight: collapsed ? "0" : "10px" }}>
                  {item.icon}
                </span>
                {!collapsed && item.text}
              </Nav.Link>
            ))}
          </Nav>
        </Container>

        {/* Botón de Cerrar Sesión */}
        <div
          style={{
            padding: "10px 15px",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "flex-start",
            cursor: "pointer",
            color: "#d32f2f", // Color rojo para indicar acción de salida
            backgroundColor: "transparent",
            borderLeft: "none",
            borderRadius: "4px",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#ffebee", // Fondo rojo claro al hover
            },
          }}
          onClick={handleLogoutClick}
        >
          <span
            style={{
              marginRight: collapsed ? "0" : "10px",
              color: "#d32f2f", // Asegurar que el icono también sea rojo
            }}
          >
            <FiLogOut />
          </span>
          {!collapsed && (
            <span
              style={{
                fontWeight: "500", // Texto un poco más grueso
                fontSize: "14px",
              }}
            >
              Cerrar Sesión
            </span>
          )}
        </div>

        <div
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: collapsed ? "center" : "flex-start",
          }}
        >
          <button
            onClick={toggleSidebar}
            style={{
              backgroundColor: "#f0ad4e",
              border: "none",
              borderRadius: "50%",
              width: "35px",
              height: "35px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0px 0px 4px rgba(0,0,0,0.3)",
            }}
          >
            {collapsed ? (
              <FiChevronRight size={20} />
            ) : (
              <FiChevronLeft size={20} />
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
